// components/common/NoItemsFound.jsx
import { FiSearch } from "react-icons/fi";

const NoItemsFound = ({ message1 = "No items found", message2 }) => {
  return (
    <div className="w-full flex justify-center items-center py-20 px-4">
      <div className="bg-quaternary/10 border border-quaternary/40 text-quaternary px-6 py-4 rounded-md text-center max-w-xl w-full shadow-md flex flex-col items-center gap-2">
        <FiSearch className="text-quaternary w-16 h-16" />
        <p className=" text-lg">{message1}</p>
        {message2 && <p className="text-sm text-quaternary font-mono">{message2}</p>}
      </div>
    </div>
  );
};

export default NoItemsFound;
